import React, { Fragment } from "react";

import {
  Button,
  Checkbox,
  Grid,
  CardContent,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Tooltip,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";

//icons
import BlockIcon from "@mui/icons-material/Block";
import DeleteIcon from "@mui/icons-material/Delete";
import BackupIcon from "@mui/icons-material/Backup";

//config
import { RutinaLeerArchivoInputFile } from "../../../Utilidades/ManejoArchivos";
import CarpetasAdjuntos from "../../../Configuracion/Llaves/CarpetasAdjuntos";
import { ValidarFormatoArchivo } from "../../../Actions/Utilidades/ValidacionesAction";
import { styleTable, StyleHome } from "../../Tool/Style";
import {
  StyledTableCellClass,
  StyledTableRowClass,
  StyledTableRowHeaderClass,
} from "../../../theme/themeTableRow";
import { MostrarMensaje } from "../../../Utilidades/ManejoMensajes";

//hook
import { useGlobalState } from "../../../Utilidades/useGlobalState";

//config home
import { MOBILE } from "../config";

//context
import { dispatchAdmision } from "../Context/store";

const Input = styled("input")({
  display: "none",
});

const RequisitosMultiple = ({
  deviceIs = "DESKTOP",
  ListaRequisitosAdmision = [],
}) => {
  const { etiquetas, dispatch } = useGlobalState();

  const admisionDispatch = dispatchAdmision();

  const guardarDataArchivo = async (e, aprRequirementIdFk) => {
    const fileInfo = await RutinaLeerArchivoInputFile(e);

    let ProcesarSiguiente = false;

    if (CarpetasAdjuntos.RequisitosAdmision !== "") {
      const dataObject = {
        ElementId: aprRequirementIdFk,
        MimeType: fileInfo.tipo,
        ValidateCode: CarpetasAdjuntos.RequisitosAdmision,
      };

      await ValidarFormatoArchivo(dataObject).then((response) => {
        if (response.status === 200) {
          //si la respuesta fue existosa
          if (response.data === true) {
            ProcesarSiguiente = true;
          } else {
            MostrarMensaje(dispatch, "warning", ["FormartFileError"]);
          }
        } else {
          if (response.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
              response.data.errors
            );
            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
          } else {
            MostrarMensaje(dispatch, "error", [response.statusText]);
          }
        }
      });
    } else {
      MostrarMensaje(dispatch, "warning", ["FolderRequisitosAdmision"]);
    }

    if (ProcesarSiguiente) {
      const indexArray = ListaRequisitosAdmision.findIndex(
        (x) => x.aprRequirementIdFk === aprRequirementIdFk
      );

      if (indexArray < 0) return;

      let arrayDataTemporal = [...ListaRequisitosAdmision];

      let itemTemporal = { ...arrayDataTemporal[indexArray] };

      itemTemporal.fileDetail = fileInfo;

      arrayDataTemporal[indexArray] = itemTemporal;

      admisionDispatch({
        type: "changeArray",
        payload: { list: arrayDataTemporal },
      });
    }
  };

  const inputhandleClick = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  const handleChangeAccept = async (aprProgramReqId, checked) => {
    const indexArray = ListaRequisitosAdmision.findIndex(
      (x) => x.aprProgramReqId === aprProgramReqId
    );

    if (indexArray < 0) return;

    let arrayDataTemporal = [...ListaRequisitosAdmision];

    let itemTemporal = { ...arrayDataTemporal[indexArray] };

    itemTemporal.aprAcceptedByStudent = checked;

    arrayDataTemporal[indexArray] = itemTemporal;

    admisionDispatch({
      type: "changeArray",
      payload: { list: arrayDataTemporal },
    });
  };

  const abrirNuevoTab = (url) => {
    // Abrir nuevo tab
    var win = window.open(url, "_blank");
    // Cambiar el foco al nuevo tab (punto opcional)
    win.focus();
  };

  const eliminarArchivo = (aprProgramReqId) => {
    const indexArray = ListaRequisitosAdmision.findIndex(
      (x) => x.aprProgramReqId === aprProgramReqId
    );

    if (indexArray < 0) return;

    let arrayDataTemporal = [...ListaRequisitosAdmision];

    let itemTemporal = { ...arrayDataTemporal[indexArray] };

    itemTemporal.fileDetail = null;

    arrayDataTemporal[indexArray] = itemTemporal;

    admisionDispatch({
      type: "changeArray",
      payload: { list: arrayDataTemporal },
    });
  };

  return (
    <Fragment>
      <CardContent sx={{ padding: deviceIs === MOBILE ? 0 : "initial" }}>
        <Grid
          key="GridRequisitosAdmisionMultiple"
          container
          style={StyleHome.GridConteiner}
        >
          <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
            {deviceIs === MOBILE ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {ListaRequisitosAdmision.length > 0
                  ? ListaRequisitosAdmision.map((registro) => (
                      <div key={registro.aprProgramReqId + "mobile"}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{marginLeft:'-7px'}}>
                            {registro.aprAcceptRequirement ? (
                              <Checkbox
                                style={{ padding: "0px 5px" }}
                                checked={registro.aprAcceptedByStudent}
                                name="FileRequired"
                                color="primary"
                                inputProps={{
                                  "aria-label": "secondary checkbox",
                                }}
                                onChange={(e) => {
                                  handleChangeAccept(
                                    registro.aprProgramReqId,
                                    e.target.checked
                                  );
                                }}
                              />
                            ) : null}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.General.Et_Requisito}
                          </Typography>

                          <div>
                            {!(registro.aprHyperlink === "") &&
                            !(registro.aprHyperlink === null) ? (
                              <Button
                                variant="text"
                                onClick={() =>
                                  abrirNuevoTab(registro.aprHyperlink)
                                }
                                style={{
                                  textTransform: "inherit",
                                  textDecoration: "underline",
                                  color: "#283593",
                                  fontWeight: "normal",
                                }}
                              >
                                {registro.requirementDsc}
                              </Button>
                            ) : (
                                <Typography sx={StyleHome.textSecondary}>
                                    {registro.requirementDsc + "aqui viejo"}
                                </Typography>
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.Home.Et_lblDocumento}:
                          </Typography>

                          <div>
                            {registro.aprFileRequired === false ? (
                              etiquetas.General.Et_NoAplica
                            ) : (
                              <Tooltip title={etiquetas.Home.Et_lblAdjuntar}>
                                <div>
                                  <label
                                    htmlFor={
                                      "button-file-" +
                                      registro.aprRequirementIdFk
                                    }
                                  >
                                    <Input
                                      id={
                                        "button-file-" +
                                        registro.aprRequirementIdFk
                                      }
                                      type="file"
                                      disabled={registro.fileDetail !== null}
                                      onChange={(e) => {
                                        guardarDataArchivo(
                                          e,
                                          registro.aprRequirementIdFk
                                        );
                                      }}
                                      onClick={inputhandleClick}
                                    />
                                    <Button
                                      disabled={registro.fileDetail !== null}
                                      fullWidth
                                      sx={{
                                        backgroundColor: "#F6F8FB",
                                        color: "#283593",
                                        border: "1px solid #283593",
                                        "&:hover": {
                                          backgroundColor: "#EDF0F4",
                                        },
                                      }}
                                      id="attachments"
                                      variant="contained"
                                      component="span"
                                      disableElevation
                                      startIcon={
                                        <BackupIcon
                                          style={{ color: "#283593" }}
                                        />
                                      }
                                    >
                                      <Typography
                                        noWrap
                                        style={{
                                          color: "#283593",
                                          width: 80,
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        {registro.fileDetail !== null
                                          ? registro.fileDetail?.nombre
                                          : etiquetas.Home.Et_lblAdjuntar}
                                      </Typography>
                                    </Button>
                                  </label>
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.General.Et_tblAcciones}:
                          </Typography>

                          {registro.aprFileRequired === false ? (
                            <IconButton style={styleTable.BodyButtoms} disabled>
                              <BlockIcon fontSize="normal" />
                            </IconButton>
                          ) : (
                            <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                              <IconButton
                                disabled={registro.fileDetail === null}
                                onClick={() =>
                                  eliminarArchivo(registro.aprProgramReqId)
                                }
                                style={styleTable.BodyButtoms}
                              >
                                <DeleteIcon fontSize="normal" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            ) : (
              <TableContainer
                component={Grid}
                style={styleTable.TableConteiner}
              >
                <Table stickyHeader>
                  <TableHead style={styleTable.TableHeader}>
                    <StyledTableRowHeaderClass>
                      <StyledTableCellClass>
                        {etiquetas.General.Et_Requisito}
                      </StyledTableCellClass>
                      <StyledTableCellClass width="150px" Align="center">
                        {etiquetas.Home.Et_lblDocumento}
                      </StyledTableCellClass>
                      <StyledTableCellClass width="85px" Align="center">
                        {etiquetas.General.Et_tbnEliminar}
                      </StyledTableCellClass>
                    </StyledTableRowHeaderClass>
                  </TableHead>
                  <TableBody>
                    {ListaRequisitosAdmision.length > 0 ? (
                      ListaRequisitosAdmision.map((registro) => {
                        return (
                          <StyledTableRowClass key={registro.aprProgramReqId}>
                            <StyledTableCellClass component="th" scope="row">
                              {
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    {registro.aprAcceptRequirement ? (
                                      <Checkbox
                                        style={{ padding: "0px 5px" }}
                                        checked={registro.aprAcceptedByStudent}
                                        name="FileRequired"
                                        color="primary"
                                        inputProps={{
                                          "aria-label": "secondary checkbox",
                                        }}
                                        onChange={(e) => {
                                          handleChangeAccept(
                                            registro.aprProgramReqId,
                                            e.target.checked
                                          );
                                        }}
                                      />
                                    ) : null}
                                  </div>

                                  <div>
                                    {!(registro.aprHyperlink === "") &&
                                    !(registro.aprHyperlink === null) ? (
                                      <Button
                                        variant="text"
                                        onClick={() =>
                                          abrirNuevoTab(registro.aprHyperlink)
                                        }
                                        style={{
                                          textTransform: "inherit",
                                          textDecoration: "underline",
                                          color: "#283593",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        {registro.requirementDsc}
                                      </Button>
                                    ) : (
                                      registro.requirementDsc
                                    )}
                                  </div>
                                </div>
                              }
                            </StyledTableCellClass>

                            <StyledTableCellClass width="150px" Align="center">
                              {registro.aprFileRequired === false ? (
                                etiquetas.General.Et_NoAplica
                              ) : (
                                <Tooltip title={etiquetas.Home.Et_lblAdjuntar}>
                                  <div>
                                    <label
                                      htmlFor={
                                        "button-file-" +
                                        registro.aprRequirementIdFk
                                      }
                                    >
                                      <Input
                                        id={
                                          "button-file-" +
                                          registro.aprRequirementIdFk
                                        }
                                        type="file"
                                        disabled={registro.fileDetail !== null}
                                        onChange={(e) => {
                                          guardarDataArchivo(
                                            e,
                                            registro.aprRequirementIdFk
                                          );
                                        }}
                                        onClick={inputhandleClick}
                                      />
                                      <Button
                                        disabled={registro.fileDetail !== null}
                                        fullWidth
                                        sx={{
                                          backgroundColor: "#F6F8FB",
                                          color: "#283593",
                                          border: "1px solid #283593",
                                          "&:hover": {
                                            backgroundColor: "#EDF0F4",
                                          },
                                        }}
                                        id="attachments"
                                        variant="contained"
                                        component="span"
                                        disableElevation
                                        startIcon={
                                          <BackupIcon
                                            style={{ color: "#283593" }}
                                          />
                                        }
                                      >
                                        <Typography
                                          noWrap
                                          style={{
                                            color: "#283593",
                                            width: 80,
                                            backgroundColor: "transparent",
                                          }}
                                        >
                                          {registro.fileDetail !== null
                                            ? registro.fileDetail?.nombre
                                            : etiquetas.Home.Et_lblAdjuntar}
                                        </Typography>
                                      </Button>
                                    </label>
                                  </div>
                                </Tooltip>
                              )}
                            </StyledTableCellClass>
                            <StyledTableCellClass width="85px" Align="center">
                              <div style={styleTable.BodyContainerButtoms}>
                                {registro.aprFileRequired === false ? (
                                  <IconButton
                                    style={styleTable.BodyButtoms}
                                    disabled
                                  >
                                    <BlockIcon fontSize="normal" />
                                  </IconButton>
                                ) : (
                                  <Tooltip
                                    title={etiquetas.General.Et_tbnEliminar}
                                  >
                                    <IconButton
                                      disabled={registro.fileDetail === null}
                                      onClick={() =>
                                        eliminarArchivo(
                                          registro.aprProgramReqId
                                        )
                                      }
                                      style={styleTable.BodyButtoms}
                                    >
                                      <DeleteIcon fontSize="normal" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </div>
                            </StyledTableCellClass>
                          </StyledTableRowClass>
                        );
                      })
                    ) : (
                      <StyledTableRowClass>
                        <StyledTableCellClass colSpan={3}>
                          {etiquetas.General.Et_tblTableEmty}
                        </StyledTableCellClass>
                      </StyledTableRowClass>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Fragment>
  );
};

export default RequisitosMultiple;
